export const SET_OPENAISTATUS = "setOpenAIStatus"
export const SET_SHORTID = "setShortId"
export const SET_PERSONA = "setPersona"
export const SET_CHAT_DATA = "setChatData"
